import { ExternalLink, Star } from "lucide-react";

export const ReviewsSection = ({ reviews }) => (
  <section className="reviews-section" data-testid="home-google-reviews-section">
    <div className="reviews-header">
      <div>
        <span className="eyebrow" data-testid="reviews-eyebrow">Reseñas de Google</span>
        <h2 data-testid="reviews-title">Lo que dicen de Nossa</h2>
      </div>
      <a className="reviews-google-button" href={reviews.google_maps_url} target="_blank" rel="noreferrer" data-testid="reviews-google-link">
        Ver reseñas en Google <ExternalLink size={16} />
      </a>
    </div>
    <div className="reviews-score-card" data-testid="reviews-score-card">
      <div className="rating-number" data-testid="reviews-average-rating">{reviews.average_rating.toFixed(1)}</div>
      <div>
        <div className="stars-row" data-testid="reviews-stars-row">
          {[1, 2, 3, 4, 5].map((star) => <Star key={star} size={18} fill="currentColor" />)}
        </div>
        <p data-testid="reviews-total-label">{reviews.total_reviews_label}</p>
      </div>
    </div>
    <div className="reviews-grid" data-testid="reviews-cards-grid">
      {reviews.reviews.map((review) => (
        <article className="review-card" key={review.id} data-testid={`review-card-${review.id}`}>
          <div className="review-card-top">
            <span data-testid={`review-source-${review.id}`}>{review.source}</span>
            <div className="mini-stars" data-testid={`review-stars-${review.id}`}>
              {[1, 2, 3, 4, 5].map((star) => <Star key={star} size={13} fill="currentColor" />)}
            </div>
          </div>
          <p data-testid={`review-text-${review.id}`}>“{review.text}”</p>
          <strong data-testid={`review-author-${review.id}`}>{review.author}</strong>
        </article>
      ))}
    </div>
  </section>
);